import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col-auto q-gutter-md" }
const _hoisted_5 = { class: "row q-gutter-md q-mb-lg" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Show member")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_8 = { class: "row q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_resource_link = _resolveComponent("resource-link")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.currentOrganization.companyName) + " - Organization members", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_file, {
          modelValue: _ctx.csvFile,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.csvFile) = $event)),
          label: "Update members profiles",
          accept: ".csv",
          onRejected: _ctx.onRejected,
          color: "primary",
          outlined: "",
          dense: "",
          clearable: ""
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "attach_file",
              color: "orange"
            })
          ]),
          after: _withCtx(() => [
            _createVNode(_component_q_btn, {
              round: "",
              dense: "",
              flat: "",
              icon: "send",
              disable: !_ctx.canUpload,
              onClick: _ctx.updateMembers
            }, null, 8, ["disable", "onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "onRejected"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_input, {
        outlined: "",
        dense: "",
        name: "search",
        modelValue: _ctx.filter,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
        color: "primary",
        label: "Search",
        clearable: "",
        class: "col-grow"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        label: "Add member",
        color: "primary",
        onClick: _ctx.onAddMember,
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_q_table, {
      columns: _ctx.organizationMemberColumns,
      rows: _ctx.organizationMembers,
      "row-key": "name",
      filter: _ctx.filter,
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
      onRequest: _ctx.onRequest,
      loading: _ctx.loading,
      flat: ""
    }, {
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onShowMember(props.row)),
              icon: "pageview"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onDeleteMember(props.row)),
              icon: "delete"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-agreements": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreementResources(props.row), (r) => {
              return (_openBlock(), _createBlock(_component_resource_link, {
                class: "block",
                resource: r,
                key: r.id
              }, null, 8, ["resource"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "filter", "pagination", "onRequest", "loading"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_q_btn, {
        to: { name: _ctx.OrganizationsRouteNames.LIST, query: { page: _ctx.route.query.page }, params: { restoreFilters: 1 } },
        label: "Back to listing",
        color: "primary",
        outline: "",
        "no-caps": ""
      }, null, 8, ["to"]),
      _createVNode(_component_q_btn, {
        to: _ctx.currentOrganizationRoute,
        label: "Show organization",
        color: "secondary",
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["to"])
    ])
  ]))
}